import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-asistencias-prefectos">
            <div className= "titulo-asistencias-prefectos">
                <h2>
                    Registro de Justificantes
                </h2>
                <p>
                    Registra y consulta los justificantes de los Alumnos
                </p>
            </div>
        </div>
    );
};

export default Header;